const iconWidgetTable = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M2 14V2h12v12zm1.5-1.5h3.749v-1.858H3.5zm9-1.858H8.75L8.748 12.5H12.5zm0-1.5V7.071H8.75v2.071zm-9 0h3.75V7.071H3.5zm9-3.571V3.5H8.749v2.071zM7.249 3.5H3.5v2.071h3.75z"/></svg>',
};

export { iconWidgetTable as default };
